import { PreferencesContext } from './usePreferencesContext';

export type ActionTypes =
  | 'updateTimezone'
  | 'updateGradientBarVariation'
  | 'resetGradientBarVariation'
  | 'toggleSearchOverlay'
  | 'toggleSelectClientModal'
  | 'hideSelectClientModalAndShowSearchOverlay';

interface IPayload {
  timezone?: PreferencesContext['timezone'];
  timezoneOffset?: PreferencesContext['timezoneOffset'];
  gradientBarVariation?: PreferencesContext['gradientBarVariation'];
  searchOverlayVisible?: PreferencesContext['searchOverlayVisible'];
  selectClientModalVisible?: PreferencesContext['selectClientModalVisible'];
}

export interface IAction {
  type: ActionTypes;
  payload?: IPayload;
}

export function preferencesReducer(state: PreferencesContext, action: IAction): PreferencesContext {
  const { type, payload } = action;

  let newState = state;

  switch (type) {
    case 'updateTimezone': {
      newState = {
        ...state,
        timezone: payload.timezone,
        timezoneOffset: payload.timezoneOffset,
      };
      break;
    }

    case 'updateGradientBarVariation': {
      newState = {
        ...state,
        gradientBarVariation: payload.gradientBarVariation,
      };
      break;
    }

    case 'resetGradientBarVariation': {
      newState = {
        ...state,
        gradientBarVariation: import.meta.env.VITE_ENV === 'production' ? 'prod' : 'poc',
      };
      break;
    }

    case 'toggleSearchOverlay': {
      newState = {
        ...state,
        searchOverlayVisible: payload.searchOverlayVisible,
      };
      break;
    }
    case 'toggleSelectClientModal': {
      newState = {
        ...state,
        selectClientModalVisible: payload.selectClientModalVisible,
      };
      break;
    }

    case 'hideSelectClientModalAndShowSearchOverlay': {
      newState = {
        ...state,
        selectClientModalVisible: false,
        searchOverlayVisible: true,
      };
      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default preferencesReducer;
